var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container is-fluid"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth"},[_c('Filters'),_c('a',{attrs:{"id":"toTop"}},[_c('b-icon',{attrs:{"pack":"mdi","icon":"navigation"}})],1)],1),_c('div',{staticClass:"column is-four-fifths"},[_c('List')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }